import { cx } from '@eti/styles';
import { Button, Inline, LinkButton, Stack, Text, textVariants } from '@etg/wings';
import { ReactComponent as SeatIcon } from '@eti/assets/icons/Seat_thin.svg';
import { useTranslation } from '@eti/providers';
import { constants, price as priceUtils } from '@eti/utils';
import { useTravelerButton } from '../hooks/useTravelerButton';
import { blackText, blackTextButton, buttonFlex, justifyBetween, nameText, activeBorder, inactiveBorder } from '../utils/styles';
import FadeMotion from './FadeMotion';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  MOUSE_FLOW_CLASS_NAMES
} = constants;
const SingleTravelerButton = _ref => {
  let {
    traveler,
    activeTraveler,
    activeSeatAssignments,
    onChange,
    onRemoveSeat,
    activeSegment,
    handlePNRKeyDown,
    isSingleTraveler,
    travelerButtonWithRemoveLink,
    setTravelerButtonWithRemoveLink
  } = _ref;
  const {
    t
  } = useTranslation();
  const selectedSeat = activeSeatAssignments === null || activeSeatAssignments === void 0 ? void 0 : activeSeatAssignments.find(s => String(s.id) === String(traveler.id));
  const showRemove = travelerButtonWithRemoveLink === traveler.id;
  const {
    buttonRef,
    handleClick,
    handleFocus,
    isActive
  } = useTravelerButton({
    travelerId: traveler.id,
    activeTraveler,
    selectedSeat,
    onChange,
    setTravelerButtonWithRemoveLink
  });
  const renderTravelerInfo = () => /*#__PURE__*/_jsx(FadeMotion, {
    motionKey: `traveler-${traveler.id}`,
    children: /*#__PURE__*/_jsx(Text, {
      className: cx('seatMap__travelerName', MOUSE_FLOW_CLASS_NAMES, nameText),
      variant: textVariants._14_BOLD,
      children: traveler.name
    })
  });
  const renderSelectedSeatDetails = () => selectedSeat && /*#__PURE__*/_jsxs(Stack, {
    align: "start",
    spacing: 8,
    children: [renderTravelerInfo(), /*#__PURE__*/_jsxs(Inline, {
      noWrap: true,
      spacing: 8,
      children: [/*#__PURE__*/_jsx(FadeMotion, {
        motionKey: `price-${selectedSeat.price}`,
        children: /*#__PURE__*/_jsx(Text, {
          className: blackTextButton,
          children: priceUtils.formatPrice(selectedSeat.price)
        })
      }), /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: `seat-${selectedSeat.value}`,
        children: /*#__PURE__*/_jsx(Text, {
          className: blackText,
          children: selectedSeat.value
        })
      })]
    })]
  });
  const getButtonActionConfig = () => {
    if (selectedSeat) {
      const text = t('Product.SeatMap.Change.Label');
      return {
        text,
        ariaLabel: text
      };
    }
    const text = t('Seating.SelectSeat.Header.Text');
    return {
      text,
      ariaLabel: text
    };
  };
  const renderButtonContent = () => {
    const showRemoveButton = selectedSeat && (isSingleTraveler || showRemove);
    if (showRemoveButton) {
      return /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: "remove",
        children: /*#__PURE__*/_jsx(LinkButton, {
          onClick: e => {
            e.stopPropagation();
            onRemoveSeat(activeSegment, traveler.id)();
            setTravelerButtonWithRemoveLink(undefined);
          },
          children: t('Product.SeatMap.Summary.Seat.Remove')
        })
      });
    }
    if (isSingleTraveler) {
      const text = t('Product.SeatMap.No.Selection.Label');
      return /*#__PURE__*/_jsx(FadeMotion, {
        motionKey: "no-selection",
        children: /*#__PURE__*/_jsx(Text, {
          "aria-label": text,
          variant: textVariants._14_BOLD,
          children: text
        })
      });
    }
    const {
      text: buttonText,
      ariaLabel
    } = getButtonActionConfig();
    return /*#__PURE__*/_jsx(FadeMotion, {
      motionKey: selectedSeat ? 'change' : 'no-selection',
      children: /*#__PURE__*/_jsx(Text, {
        "aria-label": ariaLabel,
        variant: textVariants._14_BOLD,
        children: buttonText
      })
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    className: cx(buttonFlex, isActive ? activeBorder : inactiveBorder),
    "data-testid": `seatMapTravelerButton-${traveler.id}`,
    onClick: handleClick,
    onFocus: handleFocus,
    onKeyDown: handlePNRKeyDown,
    ref: buttonRef,
    children: /*#__PURE__*/_jsxs(Inline, {
      alignY: "top",
      className: justifyBetween,
      noWrap: true,
      spacing: 16,
      children: [/*#__PURE__*/_jsxs(Inline, {
        align: "start",
        noWrap: true,
        spacing: 4,
        children: [/*#__PURE__*/_jsx(SeatIcon, {}), selectedSeat ? renderSelectedSeatDetails() : renderTravelerInfo()]
      }), renderButtonContent()]
    })
  }, traveler.id);
};
export default SingleTravelerButton;
//# sourceMappingURL=SingleTravelerButton.js.map